import { ModuleTypeEnum } from '../types/module-type'

/**
 * Header → target expectations that BOTH import surfaces must agree on: the
 * wizard's `createFieldMappings` (apps/web csv-utils.test) and the server's
 * `autoMapImportColumns` (apps/api import-auto-map.spec). Each case is one
 * header on its own, so the server's claim-once rule and the wizard's merge
 * semantics cannot make them differ.
 *
 * Add a case whenever a synonym is added to field-synonyms.ts.
 */
export interface ImportHeaderParityCase {
  moduleType: ModuleTypeEnum
  header: string
  target: string
}

export const IMPORT_HEADER_PARITY_CASES: readonly ImportHeaderParityCase[] = [
  // Generic synonyms
  {
    moduleType: ModuleTypeEnum.CONTACT,
    header: 'Given Name',
    target: 'firstName',
  },
  { moduleType: ModuleTypeEnum.CONTACT, header: 'Surname', target: 'lastName' },
  {
    moduleType: ModuleTypeEnum.CONTACT,
    header: 'E-mail Address',
    target: 'email',
  },
  {
    moduleType: ModuleTypeEnum.CONTACT,
    header: 'Mobile Phone',
    target: 'phone',
  },
  { moduleType: ModuleTypeEnum.ENTITY, header: 'Homepage', target: 'website' },
  {
    moduleType: ModuleTypeEnum.PROJECT,
    header: 'Notes',
    target: 'description',
  },
  { moduleType: ModuleTypeEnum.DEAL, header: 'Deal Value', target: 'amount' },
  // Module synonyms
  { moduleType: ModuleTypeEnum.ENTITY, header: 'Company', target: 'name' },
  { moduleType: ModuleTypeEnum.ENTITY, header: 'Account Name', target: 'name' },
  {
    moduleType: ModuleTypeEnum.SUPPLIER,
    header: 'Vendor Name',
    target: 'name',
  },
  { moduleType: ModuleTypeEnum.DEAL, header: 'Opportunity', target: 'name' },
  { moduleType: ModuleTypeEnum.CONTACT, header: 'Full Name', target: 'name' },
  {
    moduleType: ModuleTypeEnum.CONTACT,
    header: 'Employer',
    target: 'companyName',
  },
  { moduleType: ModuleTypeEnum.CONTACT, header: 'Position', target: 'title' },
  { moduleType: ModuleTypeEnum.LEAD, header: 'Lead Name', target: 'name' },
  { moduleType: ModuleTypeEnum.TASK, header: 'Summary', target: 'name' },
  { moduleType: ModuleTypeEnum.TASK, header: 'Work Type', target: 'taskType' },
  {
    moduleType: ModuleTypeEnum.PROJECT,
    header: 'Project Name',
    target: 'name',
  },
  // Time entries — the Harvest / Toggl / Clockify vocabulary
  { moduleType: ModuleTypeEnum.TIME_ENTRY, header: 'User', target: 'member' },
  { moduleType: ModuleTypeEnum.TIME_ENTRY, header: 'Email', target: 'member' },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'First Name',
    target: 'memberFirstName',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Last Name',
    target: 'memberLastName',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Start date',
    target: 'entryDate',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Spent Date',
    target: 'entryDate',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Hours',
    target: 'duration',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Duration (decimal)',
    target: 'duration',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Project',
    target: 'project',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Notes',
    target: 'description',
  },
  {
    moduleType: ModuleTypeEnum.TIME_ENTRY,
    header: 'Billable?',
    target: 'billable',
  },
]
